'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _Product = require('../../helpers/Product');

var _B2CPostLoginFlowStrategy = require('./B2CPostLoginFlowStrategy');

var _B2CPostLoginFlowStrategy2 = _interopRequireDefault(_B2CPostLoginFlowStrategy);

var _MusicPostLoginFlowStrategy = require('../../login/strategy/MusicPostLoginFlowStrategy');

var _MusicPostLoginFlowStrategy2 = _interopRequireDefault(_MusicPostLoginFlowStrategy);

var _BusinessMusicPostLoginFlowStrategy = require('../../login/strategy/BusinessMusicPostLoginFlowStrategy');

var _BusinessMusicPostLoginFlowStrategy2 = _interopRequireDefault(_BusinessMusicPostLoginFlowStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PostLoginFlowStrategySelector = function () {
  function PostLoginFlowStrategySelector() {
    (0, _classCallCheck3.default)(this, PostLoginFlowStrategySelector);
  }

  (0, _createClass3.default)(PostLoginFlowStrategySelector, null, [{
    key: 'getPostLoginFlowStrategy',
    value: function getPostLoginFlowStrategy(auth, appInfo, pushState, log) {
      var postLoginFlowStrategy = void 0;
      var productName = auth.productName;
      var realm = auth.realm;
      switch (productName) {
        case _Product.PRODUCT_NAMES.Classica:
        case _Product.PRODUCT_NAMES.Karaoke:
        case _Product.PRODUCT_NAMES.Qello:
          postLoginFlowStrategy = new _B2CPostLoginFlowStrategy2.default(auth, appInfo, pushState, log);
          break;
        case _Product.PRODUCT_NAMES.Music:
          switch (realm) {
            case _Product.REALM_NAMES.Business:
              postLoginFlowStrategy = new _BusinessMusicPostLoginFlowStrategy2.default(auth, appInfo, pushState, log);
              break;
            case _Product.REALM_NAMES.Stingray:
              postLoginFlowStrategy = new _MusicPostLoginFlowStrategy2.default(auth, appInfo, pushState, log);
              break;
            default:
              throw new Error('Realm ' + realm + ' not supported');
          }
          break;
        default:
          throw new Error('Product ' + productName + ' not supported');
      }

      return postLoginFlowStrategy;
    }
  }]);
  return PostLoginFlowStrategySelector;
}();

exports.default = PostLoginFlowStrategySelector;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/login/strategy/PostLoginFlowStrategySelector.js
// module id = 202
// module chunks = 0